import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {Http, HttpModule, RequestOptions} from '@angular/http';
import {AppRoutingModule} from './app-routing.module';
import {AktiviteterService} from './aktiviteter.service';
import {AktivitetListComponent} from './aktiviteter.component';
import {AktivitetDetailComponent} from './aktivitet.component';
import {BroderkortComponent} from './broderkort.component';
import {MedaljtypPipe} from './medaljtyp.pipe';
import {PanelComponent} from './panel.component';
import {BootstrapModalModule} from 'ng2-bootstrap-modal';
import {ConfirmComponent} from './confirm.component';
import {LimitPipe} from './limit.pipe';
import {AuthGuard} from './auth.guard';
import {LoginComponent} from './login.component';
import {AuthConfig, AuthHttp} from 'angular2-jwt';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TilldelningComponent} from './tilldelning.component';
import {ConsminlistaImportComponent} from './consminlista-import.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PermanentaMedaljerComponent} from './permanenta.component';

@NgModule({
    imports: [
        BootstrapModalModule,
        BrowserModule,
        HttpModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule
    ],
    declarations: [
        AppComponent,
        AktivitetDetailComponent,
        AktivitetListComponent,
        BroderkortComponent,
        PanelComponent,
        MedaljtypPipe,
        LimitPipe,
        ConfirmComponent,
        PermanentaMedaljerComponent,
        TilldelningComponent,
        LoginComponent,
        ConsminlistaImportComponent],
    entryComponents: [
        ConfirmComponent,
        PermanentaMedaljerComponent,
        TilldelningComponent
    ],
    providers: [
        AktiviteterService,
        AuthGuard,
        AuthHttp,
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        }

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
    return new AuthHttp(new AuthConfig({
        headerName: 'Authorization',
        headerPrefix: 'bearer',
        tokenName: 'token',
        tokenGetter: (() => localStorage.getItem('token')),
        globalHeaders: [{'Content-Type': 'application/json'}],
        noJwtError: true,
    }), http, options);
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/app.module.ts